import { Alert, Skeleton } from "@mui/material";
import { useGetCCDataQuery, useGetCCFromTemplateQuery } from "modules/pvs_activities/redux/service/dForm";
import React, { useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import { FormDataContext } from "../contexts/FormContext";
import { processVariables } from "modules/pvs_activities/helper.general";
import { useGetFormDataVariablesQuery } from "modules/pvs_activities/redux/service/formData";

const CCSummaryTable = (props) => {
    const formDataContext = useContext(FormDataContext);
    const siteLanguage = useSelector((s) => s.general.siteLanguage);

    const variablesRes = useGetFormDataVariablesQuery(formDataContext.missionId, {
        skip: formDataContext.mode !== "data_entry"
    });
    const ccListRes = useGetCCFromTemplateQuery({
        formId: formDataContext.templateId,
        languageId: 3,
        missionId: formDataContext.missionId,
    });
    const ccDataRes = useGetCCDataQuery(
        {
            formId: formDataContext.templateId,
            // elementId: props.element?.id ?? '',
            movementId: formDataContext.movementId,
            key: "loa_score",
            tagName: "CCLOAChange",
        },
        { skip: formDataContext.mode === "preview" }
    );

    const ccData = useMemo(() => {
        if (ccDataRes.isSuccess) return { ...ccDataRes.data };
        return {};
    }, [ccDataRes]);

    return ccListRes.isLoading ? (
        <>
            <Skeleton variant="rounded" width={"100%"} height={200} sx={{ my: 1 }} />
        </>
    ) : ccListRes.isError ? (
        <>
            <Alert severity="warning" sx={{ my: 1 }}>
                Error loading Critical Competency List
            </Alert>
        </>
    ) : ccListRes.isSuccess ? (
        <>
            <table className="table table-bordered border-dark">
                <thead>
                    <tr className="bg-primary text-white">
                        <th className="text-center">
                            PVS Summary results of {processVariables(variablesRes, "{country}")}
                        </th>
                        <th className="text-center" width="20%">
                            Results
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {ccListRes.data.map((r) => (
                        <tr key={r.id} className={`${r.is_cc ? "" : "bg-light-3"}`}>
                            <td
                                colSpan={r.is_cc === 0 ? 2 : 1}
                                style={{ fontWeight: r.is_cc === 0 ? "bold" : "normal" }}
                            >
                                {siteLanguage === "3"
                                    ? r.complete_name_en
                                    : siteLanguage === "4"
                                    ? r.complete_name_fr
                                    : siteLanguage === "5"
                                    ? r.complete_name_es
                                    : r.complete_name}
                            </td>
                            {r.is_cc === 1 && (
                                <td className="text-center">{ccData[r.id]?.loa_score?.content ?? "-"}</td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    ) : (
        ""
    );
};

CCSummaryTable.defaultProps = {
    id: "",
    element: {},
    isReadOnly: true,
};

export default CCSummaryTable;
